<div class="container">
  <h2 class="title">Slider Yönetimi</h2>

  <div class="action-buttons">
    <button (click)="addSlider()" class="button primary">
      <i class="fas fa-plus"></i>
      <span>Yeni Slider Ekle</span>
    </button>
    <button (click)="saveSliders()" class="button success">
      <i class="fas fa-save"></i>
      <span>Kaydet</span>
    </button>
  </div>

  <div class="slider-list">
    <div *ngFor="let slider of sliders; let i = index" class="slider-card">
      <div class="card-content">
        <div class="image-section">
          <app-image-uploader [src]="slider.imageUrl"
          (fileSelected)="onFileSelected($event, slider)"></app-image-uploader>
        </div>
        
        <div class="form-section">
          <div class="form-group">
            <label>Başlık</label>
            <input [(ngModel)]="slider.title" class="form-control" placeholder="Başlık" />
          </div>
          
          <div class="form-group">
            <label>İçerik</label>
            <textarea [(ngModel)]="slider.content" class="form-control" placeholder="İçerik"></textarea>
          </div>

          <div class="button-groups">
            <div class="button-row">
              <div class="form-group">
                <label>Buton Adı</label>
                <input [(ngModel)]="slider.text1" class="form-control" />
              </div>
              <div class="form-group">
                <label>Buton Link</label>
                <input [(ngModel)]="slider.link1" class="form-control" />
              </div>
            </div>

            <div class="button-row">
              <div class="form-group">
                <label>Buton Adı</label>
                <input [(ngModel)]="slider.text2" class="form-control" />
              </div>
              <div class="form-group">
                <label>Buton Link</label>
                <input [(ngModel)]="slider.link2" class="form-control" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-footer">
        <button (click)="confirmDelete(i)" class="button danger">
          <i class="fas fa-trash-alt"></i>
          <span>Sil</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Silme Onay Popup -->
<div *ngIf="showDeleteConfirm" class="delete-confirm-overlay">
  <div class="delete-confirm-popup">
    <div class="popup-header">
      <h3>Silme Onayı</h3>
    </div>
    <div class="popup-content">
      <p>Silmek istediğinize emin misiniz?</p>
    </div>
    <div class="popup-actions">
      <button (click)="cancelDelete()" class="button secondary">
        <span>İptal</span>
      </button>
      <button (click)="confirmDeleteSlider()" class="button danger">
        <span>Sil</span>
      </button>
    </div>
  </div>
</div>
